import * as React from 'react';
import './OnboardingNavbar.scss';
import { useSelector } from 'react-redux';
import { onboardingSelector } from '../../reducers/onboarding';
import styled from 'styled-components';
import { StandardTooltipOverlay } from '../../constants';
import { Tooltip } from '@rtkwlf/ui';
import Icon from '../../widgets/Icons';
import { CloudSensorLabels } from './cloud-sensor-config/OnboardingCloudSensorConfig';

const UnorderedList = styled.ul`
  list-style: none;
`;

const CheckItem = styled.li`
  &:before {
    color: green;
    content: '✓';
    font-weight: bold;
    display: inline-block;
    width: 1.5em;
    margin-left: -1.5em;
  }
`;

CheckItem.displayName = 'CheckItem';

const OnboardingProductlist: React.FunctionComponent = () => {
  const cs = useSelector(onboardingSelector.hasPurchasedCloudSensors);
  const purchasedCloudSensors = useSelector(
    onboardingSelector.getOnboardingProducts,
  ).cloudSensors;
  const cspm = useSelector(onboardingSelector.hasCSPM);
  const ma = useSelector(onboardingSelector.isManagedAwarenessEnabled);
  const mdr = useSelector(onboardingSelector.isManagedDetectionEnabled);
  const mr = useSelector(onboardingSelector.isManagedRiskEnabled);
  const irjs = useSelector(onboardingSelector.isIRJSEnabled); //legacy
  const jumpStartRetainer = useSelector(onboardingSelector.isJumpStartEnabled);
  const incident360 = useSelector(onboardingSelector.isIncident360Enabled);
  const incident360Plus = useSelector(
    onboardingSelector.isIncident360PlusEnabled,
  );
  const rapidResponse = useSelector(onboardingSelector.isRapidResponseEnabled);

  const cloudSensors = React.useMemo(
    () =>
      purchasedCloudSensors.map((c) => <li key={c}>{CloudSensorLabels[c]}</li>),
    [purchasedCloudSensors],
  );

  return (
    <div>
      <h3 className="pb-2">Purchased Products</h3>
      <UnorderedList>
        {irjs && <CheckItem>IR-JumpStart</CheckItem>}
        {jumpStartRetainer && <CheckItem>JumpStart Retainer</CheckItem>}
        {incident360 && (
          <CheckItem>
            Incident360 Retainer
            <ul>{rapidResponse && <li>Rapid Response</li>}</ul>
          </CheckItem>
        )}
        {incident360Plus && (
          <CheckItem>
            Incident360 Retainer Plus
            <ul>{rapidResponse && <li>Rapid Response</li>}</ul>
          </CheckItem>
        )}
        {mdr && <CheckItem>Managed Detection</CheckItem>}
        {mr && (
          <CheckItem>
            Managed Risk
            <ul>
              {cspm && (
                <li>
                  CSPM
                  <Tooltip
                    className="ml-2"
                    placement={'left'}
                    overlay={
                      <StandardTooltipOverlay>
                        <p>
                          <b>Cloud Security Posture Management</b>
                        </p>
                        As part of your Arctic Wolf Managed Risk service, the
                        cloud security posture management feature scans your
                        environment against thousands of generally accepted
                        cloud configuration benchmarks managed by your Concierge
                        Security Team. The CST provides you with cloud inventory
                        reporting, cloud environment benchmarking, and posture
                        hardening recommendations.
                      </StandardTooltipOverlay>
                    }
                  >
                    <Icon.Question />
                  </Tooltip>
                </li>
              )}
            </ul>
          </CheckItem>
        )}
        {cs && (
          <CheckItem>
            Cloud Sensors
            <ul>{cloudSensors}</ul>
          </CheckItem>
        )}
        {ma && <CheckItem>Managed Awareness</CheckItem>}
      </UnorderedList>
    </div>
  );
};

export default OnboardingProductlist;
